<template>
  <div
    v-if="isShowButtomElem || isShowEditMesModal"
    :class="['bottom-elem', { show: isShowEditMesModal }]"
  >
    <div id="button">発注車両リスト</div>
    <form id="container" @submit.prevent="nextOrderConfirm">
      <div class="content">
        <section id="vehicle-list" class="p-1 p-lg-0">
          <div>
            <md-table
              v-model="vehicles"
              class="p-2 p-lg-0 h-100"
              md-sort="name"
              md-sort-order="asc"
              md-card
              md-fixed-header
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="車名" md-sort-by="name">
                  <span v-if="!isMobile">
                    <span v-if="item.isIrekae" class="red">
                      【入れ替え車両】
                    </span>
                    {{ omitText(item.name, 39) }}
                  </span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold">車名</p>
                    <p class="col-9 p-0">
                      <span v-if="item.isIrekae" class="red">
                        【入れ替え車両】
                      </span>
                      {{ _omitText(item.name, 10) }}
                    </p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="車台番号/登録番号" md-sort-by="number">
                  <span v-if="!isMobile">{{ omitText(item.number, 45) }}</span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold">
                      車台番号
                      <br />
                      登録番号
                    </p>
                    <p class="col-9 p-0">{{ _omitText(item.number, 16) }}</p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="" md-sort-by="" class="text-right">
                  <button
                    type="button"
                    class="btn btn-success bold sp-fs-14"
                    @click="editSyaryoList(item.id)"
                    :disabled="disabled"
                  >
                    編集
                  </button>
                  <button
                    v-if="item.isShowDelBtn"
                    type="button"
                    class="btn btn-secondary bold sp-fs-14"
                    @click="confirmDeleteSyaryoList(item)"
                    :disabled="disabled"
                  >
                    削除
                  </button>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </div>

          <div class="mt-2 mt-md-3 text-center">
            <md-button
              type="submit"
              class="
                md-raised
                btn-lg btn-success
                base-btn
                col-6 col-md-4
                mx-5
                next-btn
              "
              :disabled="disabled || isNextDisabled"
            >
              次へ
            </md-button>
          </div>
        </section>
      </div>

      <div class="text-right my-2 mr-3">
        <md-dialog-alert
          class="new"
          :md-fullscreen="false"
          @md-opened="
            scroll('locked')
            hideDialogAction()
          "
          @md-closed="LowerSyaryoList"
          :md-active.sync="isShowEditMesModal"
          :md-content="getAlertMessage()"
        />

        <md-dialog-confirm
          class="new"
          :md-fullscreen="false"
          @md-opened="scroll('locked')"
          @md-closed="scroll('clear')"
          :md-active.sync="isDeleteConfirm"
          md-title=""
          :md-content="getConfirmDeleteMessage()"
          md-confirm-text="はい"
          md-cancel-text="いいえ"
          @md-confirm="deleteSyaryoList"
        />
      </div>
    </form>
  </div>
</template>

<script>
import Mixin from '@/components/mixin/Mixin'
import Store from '@/store/index.js'
import jQuery from 'jquery'

const $ = jQuery
const MAX_TABLE_RECORD = 2.6 // テーブルにスクロールしないで表示するレコード数の最大値
const ROW_HEIGHT = 50

export default {
  name: 'SyaryoList',
  mixins: [Mixin],
  data: () => ({
    vehicles: [],
    selectedItem: {},
    isDeleteConfirm: false,
    isShowEditMesModal: false,
    disabled: false,
    isNextDisabled: false,
  }),
  methods: {
    addVehicles() {
      Store.commit('vehicle/execAddVecle')
    },
    hideDialogAction() {
      $('.md-dialog-actions').hide()
    },
    getConfirmDeleteMessage() {
      return `<strong>「${this.selectedItem.name}」を削除してもよろしいですか？</strong>`
    },
    getAlertMessage() {
      return this.isIrekae()
        ? `<strong>発注車両リスト内の入れ替え車両の編集ボタンをクリックし、車両情報の編集を行ってください。</strong>`
        : `<strong>車両を編集する場合は、発注車両リスト内の編集ボタンをクリックしてください。<br>車両を追加する場合は、車両情報を入力してください。</strong>`
    },
    LowerSyaryoList() {
      this.scroll('clear')
      Store.commit('vehicle/setIsShowSyaryoList', false)
    },
    // 発注確認画面へ遷移
    async nextOrderConfirm() {
      this.isNextDisabled = true
      Store.commit('order/setNextConfirmFlg')
      await this.sleep(5000)
      this.isNextDisabled = false
    },
    confirmDeleteSyaryoList(item) {
      this.selectedItem = item
      this.isDeleteConfirm = true
    },
    // 車両リスト削除
    deleteSyaryoList() {
      this.scroll('clear')
      Store.commit('vehicle/setDeleteId', this.selectedItem.id)
    },
    // 車両リスト編集
    editSyaryoList(id) {
      this.scroll('clear')
      Store.commit('vehicle/setEditId', id)
    },
    isIrekae() {
      let result = false
      for (const v of this.vehicles) {
        if (v.isIrekae) {
          result = true
          break
        }
      }
      return result
    },
  },
  computed: {
    vehicleList() {
      return Store.state.vehicle.list
    },
    isShowSyaryoList() {
      return Store.state.vehicle.isShowSyaryoList
    },
    isShowButtomElem() {
      return (
        Store.state.vehicle.isShowButtomElem && Store.state.vehicle.list.length
      )
    },
    isIrekaeMode() {
      return Store.state.vehicle.mode === 'irekae'
    },
  },
  watch: {
    isShowSyaryoList(flg) {
      this.isShowEditMesModal = flg
    },
    vehicleList(list) {
      this.vehicles = list
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../assets/css/logico2'
// 下からにゅっと現れるやつ
.bottom-elem
  position: fixed
  z-index: 10
  bottom: 0
  left: 0
  overflow: hidden
  width: 100%
  height: 60px
  margin: 0 auto
  -webkit-transition: all 1s ease
  transition: all 1s ease
  @include sp
    height: 60px
  &:hover
    height: 340px
    -webkit-transition: all 1s ease
    transition: all 1s ease
    @include sp
      height: 260px
  #button
    position: relative
    width: 10em
    height: 60px
    margin: 0 auto
    padding: 0.2em
    cursor: pointer
    -webkit-transition: all 1s ease
    transition: all 1s ease
    text-align: center
    color: #fff
    font-weight: bold
    font-size: 30px
    border-radius: 3px 3px 0px 0px
    background: rgba(255,165,0,0.8)
    @include sp
      height: 40px
      font-size: 24px
    &:hover
      position: relative
      width: 10em
      height: 60px
      -webkit-transition: all 1s ease
      transition: all 1s ease
      @include sp
        height: 40px
  #container
    position: relative
    top: 0
    left: 0
    width: 100%
    height: 100%
    background: #f8f8ff
    border-top: 2px solid #ced4da
.bottom-elem.show
  height: 340px
  @include sp
    height: 60px
</style>



// WEBPACK FOOTER //
// src/components/SyaryoList.vue